import { defineFetch } from 'resift';

const makeGetPermissionScopedEntities = defineFetch({
  displayName: 'Get Permission Scoped Entities',
  make: (roleId: string, permissionId: string) => ({
    request: (excluded?: boolean) => ({ http }) =>
      http({
        method: 'GET',
        route: `/roles/${roleId}/permissions/${permissionId}/scoped-entities`,
        query: {
          // "true" if adding to the exclusion list, "false" if adding to the inclusion list; if none passed, will return both manually excluded and included entities
          excluded,
        },
      }),
  }),
});

export default makeGetPermissionScopedEntities;
